export const handleMeshClickMethodSymbol = Symbol("Layer3D::handleMeshClick");
export const handleMeshMouseEnterMethodSymbol = Symbol("Layer3D::handleMeshMouseEnter");
export const handleMeshMouseLeaveMethodSymbol = Symbol("Layer3D::handleMeshMouseLeave");
export const handleMeshMouseDownSymbol = Symbol("Layer3D::handleMouseDown");
export const handleMeshMouseUpSymbol = Symbol("Layer3D::handleMouseUp");
export const prepareRenderMethodSymbol = Symbol("Layer3D::prepareRender");
export const handleMeshDoubleClickMethodSymbol = Symbol("Layer3D::handleMeshDoubleClick");

export const getItem3DEventTypesSymbol = Symbol("Item3D::getItem3DEventTypes");
export const getItem3DDollySymbol = Symbol("Item3D::getItem3DDolly");
